/* DaHausLab — comportamiento de marca (reveal, tilt, contador, selector tier x packs) */

function activarReveal() {
  const els = document.querySelectorAll('.reveal:not(.visible)');
  if (!('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('visible')); return; }
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('visible'); io.unobserve(entry.target); } });
  }, { threshold: 0.12 });
  els.forEach(e => io.observe(e));
}

function activarTilt() {
  document.querySelectorAll('.tarjeta').forEach(card => {
    const visual = card.querySelector('.jar-visual img, .jar-visual svg');
    card.addEventListener('mousemove', e => {
      const r = card.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      card.style.transition = 'none';
      card.style.transform = `perspective(700px) rotateY(${x * 12}deg) rotateX(${-y * 10}deg) translateZ(4px)`;
      if (visual) visual.style.transform = `translateX(${x * 8}px) translateY(${y * 6}px) scale(1.06)`;
    });
    card.addEventListener('mouseleave', () => {
      card.style.transition = 'transform 500ms cubic-bezier(.25,.46,.45,.94), box-shadow 500ms ease';
      card.style.transform = '';
      if (visual) { visual.style.transition = 'transform 500ms cubic-bezier(.25,.46,.45,.94)'; visual.style.transform = ''; }
    });
  });
}

/* Cuenta regresiva con días, horas, minutos y segundos — corre en vivo, cada segundo. */
function iniciarContador(elId, fechaObjetivo) {
  const el = document.getElementById(elId);
  if (!el) return;
  const destino = new Date(fechaObjetivo || '2026-10-31T00:00:00');
  if (isNaN(destino)) return;
  const dosDigitos = n => String(n).padStart(2, '0');
  function actualizar() {
    const diff = Math.max(0, destino - new Date());
    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff % 86400000) / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    el.innerHTML = `
      <div class="bloque"><span class="num">${d}</span><span class="lbl">Días</span></div>
      <div class="bloque"><span class="num">${dosDigitos(h)}</span><span class="lbl">Horas</span></div>
      <div class="bloque"><span class="num">${dosDigitos(m)}</span><span class="lbl">Min</span></div>
      <div class="bloque"><span class="num">${dosDigitos(s)}</span><span class="lbl">Seg</span></div>`;
  }
  actualizar();
  setInterval(actualizar, 1000);
}

/* Selector tier (variante) x cantidad de packs — lee variantes reales del producto vía data-attrs.
   IMPORTANTE sobre el modelo de precios: en Shopify, "Docena"/"Pack 24" guardan el precio TOTAL
   del bulto (esBundle:true), mientras que "Unidad"/"Lote 60"/"Distribuidor" guardan el precio
   POR UNIDAD directamente (esBundle:false). Por eso la cantidad real que se envía a /cart/add
   (shopifyQty) es distinta según el tipo: para bundles es simplemente "packs" (cada pack ya trae
   su precio total), pero para precio-por-unidad hay que enviar unidades×packs, si no Shopify
   cobraría solo el precio de 1 unidad sin importar cuántas se estén llevando.
   Distribuidor (esCaja:true) se vende por caja cerrada de fábrica: qty = unidades por caja y
   minPacks = cajas mínimas para llegar a 200 unidades. */
function activarSelectorProducto() {
  const wrap = document.querySelector('[data-selector-producto]');
  if (!wrap) return;

  const variantes = JSON.parse(wrap.dataset.variantes || '[]');
  if (!variantes.length) return;

  let activa = variantes[variantes.length - 1];
  let packs = activa.minPacks || 1;

  const pillsEl = wrap.querySelector('#tier-pills');
  const packNumEl = wrap.querySelector('#pack-num');
  const packLblEl = wrap.querySelector('#pack-lbl-desc');
  const detalle = wrap.querySelector('#resumen-detalle');
  const totalEl = wrap.querySelector('#resumen-total');
  const inputId = wrap.querySelector('#dhl-variant-id');
  const inputQty = wrap.querySelector('#dhl-variant-qty');

  function money(n) {
    return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(n);
  }

  function renderPills() {
    pillsEl.innerHTML = variantes.map(v => `
      <button type="button" class="tier-pill${v.id === activa.id ? ' activo' : ''}" data-id="${v.id}">
        ${v.label}
        <small>${money(v.precioUnidad)}/u</small>
      </button>`).join('');
    pillsEl.querySelectorAll('.tier-pill').forEach(btn => {
      btn.addEventListener('click', () => {
        activa = variantes.find(v => String(v.id) === btn.dataset.id);
        packs = activa.minPacks || 1;
        renderPills();
        actualizarResumen();
      });
    });
  }

  function actualizarResumen() {
    const unidades = activa.qty * packs;
    const total = activa.precioUnidad * unidades;
    const shopifyQty = activa.esBundle ? packs : unidades;
    packNumEl.textContent = packs;
    if (activa.esCaja) {
      const minimo = activa.minPacks > 1 ? ` · mínimo ${activa.minPacks} cajas` : '';
      packLblEl.textContent = `${packs === 1 ? 'caja' : 'cajas'} × ${activa.qty} u. = ${unidades} unidades${minimo}`;
      detalle.textContent = `${packs} ${packs === 1 ? 'caja cerrada' : 'cajas cerradas'} × ${activa.qty} unidades (${money(activa.precioUnidad)}/u)`;
    } else {
      packLblEl.textContent = `× ${activa.qty} u. = ${unidades} unidades`;
      detalle.textContent = `${packs} × ${activa.qty} unidades (${money(activa.precioUnidad)}/u)`;
    }
    totalEl.textContent = `Total: ${money(total)}`;
    if (inputId) inputId.value = activa.id;
    if (inputQty) inputQty.value = shopifyQty;
  }

  wrap.querySelector('#btn-menos')?.addEventListener('click', () => { if (packs > (activa.minPacks || 1)) { packs--; actualizarResumen(); } });
  wrap.querySelector('#btn-mas')?.addEventListener('click', () => { packs++; actualizarResumen(); });

  renderPills();
  actualizarResumen();
}

document.addEventListener('DOMContentLoaded', () => {
  activarReveal();
  activarTilt();
  activarSelectorProducto();
});
